import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "sun-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 4 }),
        React.createElement("path", { strokeLinecap: "round", d: "M8.5 1.5v1m4.95 1.05-.708.707M15.5 8.5h-1m-1.05 4.95-.707-.707M8.5 15.5v-1m-4.95-1.05.707-.707M1.5 8.5h1m1.05-4.95.708.707" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
